import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Attachment } from 'src/app/_metronic/core/classes/core.class';
import { AppConstant } from 'src/app/app.constant';
import { ToasterService, ToasterType } from 'src/app/services/toaster/toaster.service';

@Injectable({
    providedIn: 'root',
})
export class SeminarWorkshopService {
    apiUrl: string;
    constructor(private httpClient: HttpClient, private appConstant: AppConstant, private toasterService: ToasterService) {
        this.apiUrl = this.appConstant.getUrl();
    }

    // manageSeminar(seminar) {
    //     return this.httpClient.post(`${this.apiUrl}/manageSeminar`, seminar).pipe(
    //         map((response: any) => {
    //             return response;
    //         })
    //     );
    // }

    public getAllSeminar(): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllActivity/`, {}).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total,
                } as GridDataResult;
            })
        ) as any as Observable<GridDataResult>;
    }

    getAllSeminarExcel() {
        return new Promise((resolve, reject) => {
            this.httpClient
                .post(`${this.apiUrl}/getAllActivity/`, {})
                .pipe(map((res) => res))
                .subscribe(
                    (res) => {
                        resolve(res);
                    },
                    (err) => {
                        reject(err);
                    }
                );
        });
    }

    // getSeminarById(Id: number) {
    //     return this.httpClient.get(`${this.apiUrl}/getSeminarById/` + Id).pipe(
    //         map((response: any) => {
    //             return response;
    //         })
    //     );
    // }

    getSeminarById(Id: number) {
        return new Promise((resolve, reject) => {
            this.httpClient
                .get(`${this.apiUrl}/getActivityById/` + Id,)
                .pipe(map((res) => res))
                .subscribe(
                    (res) => {
                        resolve(res);
                    },
                    (err) => {
                        this.toasterService.showToaster(null, err.error?.data || 'Something went wrong please try again!', ToasterType.Error);
                        reject(err);
                    }
                );
        });
    }


    manageSeminarStatus(data) {
        return new Promise((resolve, reject) => {
            this.httpClient
                .post(`${this.apiUrl}/manageActivityStatus`, data)
                .pipe(map((res) => res))
                .subscribe(
                    (res) => {
                        resolve(res);
                    },
                    (err) => {
                        this.toasterService.showToaster(null, err.error?.data || 'Something went wrong please try again!', ToasterType.Error);
                        reject(err);
                    }
                );
        });
    }

    manageSeminar(data) {
        return new Promise((resolve, reject) => {
            this.httpClient
                .post(`${this.apiUrl}/manageActivity`, data)
                .pipe(map((res) => res))
                .subscribe(
                    (res) => {
                        resolve(res);
                    },
                    (err) => {
                        this.toasterService.showToaster(null, err.error?.data || 'Something went wrong please try again!', ToasterType.Error);
                        reject(err);
                    }
                );
        });
    }
    manageSeminarDocument(seminar) {
        return this.httpClient.post(`${this.apiUrl}/manageActivityDocument`, seminar).pipe(
          map((response: any) => {
            return response;
          })
        )
    }
    ManageSeminarCompleted(seminar) {
        return this.httpClient.post(`${this.apiUrl}/manageActivityCompleted`, seminar).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    addAttachments(attachments: Attachment[]) {
        return new Promise((resolve, reject) => {
            this.httpClient
                .post(`${this.apiUrl}/fileBulkUpload`, attachments)
                .pipe(map((res) => res))
                .subscribe(
                    (res) => {
                        resolve(res);
                    },
                    (err) => {
                        reject(err);
                    }
                );
        });
    }
    
    deleteAttachments(attachments: Attachment) {
        return this.httpClient.post(`${this.apiUrl}/fileBulkDelete`, attachments).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
}
